module.exports = __webpack_public_path__ + "static/media/ul.037f7751.svg";